export default __webpack_public_path__ + "static/media/JobJournal.3bcecf71c7bcb3c8ebbef17137d7757f.webp";